import React, {useEffect, useState} from 'react';
import FullScreenMap from '../map/FullScreenMap';
import PanelDetails from '../beachDetails/PanelDetails';

import HeaderApp from '../header/HeaderApp';
import I18n from '../../languages/I18n';
import {useDispatch} from 'react-redux';
import {getBeaches} from '../../redux/actions/beachesActions';

const AppLoadingScreen = props => {
  const dispatch = useDispatch();
  const [panelVisible, setPanelVisible] = useState(false);
  const [language, setLanguage] = useState('fr');
  const width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  const [isSmall, setIsSmall] = useState(width < 800 ? true : false);
  const [headerVisible, setHeaderVisible] = useState(true);

  const changeLanguage = lang => {
    I18n.defaultLocale = lang;
    I18n.locale = lang;
    localStorage.setItem('@plouf:language', lang);
    setLanguage(lang);
    dispatch(getBeaches(lang));
  };

  const toggleHeaderVisible = () => {
    setHeaderVisible(v => !v);
  };

  const updateDimensions = () => {
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    setIsSmall(width < 800);
  };

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);

    I18n.defaultLocale = 'fr';
    I18n.locale = 'fr';
    var language = localStorage.getItem('@plouf:language');

    if (language === null) {
      if (navigator.language.includes('fr')) {
        I18n.defaultLocale = 'fr';
        I18n.locale = 'fr';
      } else if (navigator.language.includes('es')) {
        I18n.defaultLocale = 'es';
        I18n.locale = 'es';
        setLanguage('es');
      } else if (navigator.language.includes('en')) {
        I18n.defaultLocale = 'en';
        I18n.locale = 'en';
        setLanguage('en');
      }
    } else {
      I18n.defaultLocale = language;
      I18n.locale = language;
      setLanguage(language);
    }

    dispatch(getBeaches(I18n.locale));

    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, [dispatch]);

  const showPanel = () => {
    if (!panelVisible) {
      setPanelVisible(true);
    }
  };

  function hidePanel() {
    if (panelVisible) {
      setPanelVisible(false);
    }
  }

  return (
    <div>
      {headerVisible && (
        <HeaderApp
          isSmall={isSmall}
          changeLanguage={changeLanguage}
          language={language}
        />
      )}

      <div style={{position: 'relative'}}>
        <FullScreenMap
          headerVisible={headerVisible}
          toggleHeaderVisible={toggleHeaderVisible}
          panelVisible={panelVisible}
          isSmall={isSmall}
          showPanel={showPanel}
          language={language}
        />

        {panelVisible && (
          <PanelDetails
            headerVisible={headerVisible}
            isSmall={isSmall}
            hidePanel={hidePanel}
            language={language}
          />
        )}
      </div>
    </div>
  );
};

export default AppLoadingScreen;
